import { t } from "../../../../utils/i18n";
import React from "react";
import Card from ".././Card";
import VirtualCard from ".././VirtualCard";
import "../../../P2PTrades/Offers/index.scss";

const List = ({ cards, cardSecretKey }) => {
  return (
    <div className="container-fluid px-2 px-md-4 py-4">
      {/* Page Header Section */}
      <div className="mb-4 p-3 bg-light rounded-lg shadow-sm">
        <h4 className="create-trade-page-title font-weight-bold">
          <i className="fa fa-credit-card mr-2"></i>{t("cards.details.debit_cards")}
        </h4>
        <p className="mb-0 text-muted">
          {t("cards.details.manage")}
        </p>
      </div>

      {/* Row of Modernized Cards */}
      {cards && cards?.length > 0 ? (
        <div className="row">
          {cards.map((card, i) =>
            card.card_type === "virtual" ? (
              <VirtualCard
                key={card.id || i}
                card={card}
                cardSecretKey={cardSecretKey}
              />
            ) : (
              <Card key={card.id || i} card={card} />
            )
          )}
        </div>
      ) : (
        <div className="modern-alert modern-alert-info">
          <i className="fa fa-info-circle mr-2"></i> {t("cards.details.no_cards")}
        </div>
      )}
    </div>
  );
};

export default List;
